
import { SgAlert } from '@sgui-plus/components/alert'
import { SgAnchor, SgAnchorLink } from '@sgui-plus/components/anchor'
import { SgAutocomplete } from '@sgui-plus/components/autocomplete'
import { SgBadge } from '@sgui-plus/components/badge'
import { SgBreadcrumb, SgBreadcrumbItem } from '@sgui-plus/components/breadcrumb'
import { SgButton, SgButtonGroup } from '@sgui-plus/components/button'
import { SgCalendar } from '@sgui-plus/components/calendar'
import { SgCard } from '@sgui-plus/components/card'
import { SgCarousel, SgCarouselItem } from '@sgui-plus/components/carousel'
import { SgCascader } from '@sgui-plus/components/cascader'
import { SgCascaderPanel } from '@sgui-plus/components/cascader-panel'
import {
  SgCheckbox,
  SgCheckboxButton,
  SgCheckboxGroup,
} from '@sgui-plus/components/checkbox'
import { SgCol } from '@sgui-plus/components/col'
import { SgCollapse, SgCollapseItem } from '@sgui-plus/components/collapse'
import { SgCollapseTransition } from '@sgui-plus/components/collapse-transition'
import { SgColorPicker } from '@sgui-plus/components/color-picker'
import { SgComboTree } from '@sgui-plus/components/combo-tree'
import { SgDatePicker } from '@sgui-plus/components/date-picker'
import { SgDrawer } from '@sgui-plus/components/drawer'
import { SgDropdown, SgDropdownItem } from '@sgui-plus/components/dropdown'
import { SgForm, SgFormItem } from '@sgui-plus/components/form'
import { SgIcon } from '@sgui-plus/components/icon'
import { SgImage } from '@sgui-plus/components/image'
import { SgInput } from '@sgui-plus/components/input'
import { SgInputNumber } from '@sgui-plus/components/input-number'
import { SgLink } from '@sgui-plus/components/link'
import { SgLoading } from '@sgui-plus/components/loading'
import {
  SgMenu,
  SgMenuItem,
  SgMenuItemGroup,
  SgSubMenu
} from '@sgui-plus/components/menu'
import { SgMessage } from '@sgui-plus/components/message'
import { SgModal } from '@sgui-plus/components/modal'
import { SgMultiFilter } from '@sgui-plus/components/multi-filter'
import { SgNotification } from '@sgui-plus/components/notification'
import {
  SgOption,
  SgOptionGroup,
  SgSelect,
} from '@sgui-plus/components/select'
import { SgPage } from '@sgui-plus/components/page'
import { SgPageStatus } from '@sgui-plus/components/page-status'
import { SgPopconfirm } from '@sgui-plus/components/popconfirm'
import { SgPopover } from '@sgui-plus/components/popover'
import { SgPopper } from '@sgui-plus/components/popper'
import { SgProgress } from '@sgui-plus/components/progress'
import {
  SgRadio,
  SgRadioButton,
  SgRadioGroup,
} from '@sgui-plus/components/radio'
import { SgRate } from '@sgui-plus/components/rate'
import { SgResult } from '@sgui-plus/components/result'
import { SgRow } from '@sgui-plus/components/row'
import { SgScrollbar } from '@sgui-plus/components/scrollbar'
import { SgSlider } from '@sgui-plus/components/slider'
import { SgStatistic } from '@sgui-plus/components/statistic'
import { SgSwitch } from '@sgui-plus/components/switch'
import {
  SgSteps,
  SgStep
} from '@sgui-plus/components/steps'
import { SgTable, SgTableColumn } from '@sgui-plus/components/table'
import { SgTabPane, SgTab } from '@sgui-plus/components/tab'
import { SgTag } from '@sgui-plus/components/tag'
import { SgTimePicker } from '@sgui-plus/components/time-picker'
import { SgTimeSelect } from '@sgui-plus/components/time-select'
import { SgTimeline, SgTimelineItem } from '@sgui-plus/components/timeline'
import { SgTooltip } from '@sgui-plus/components/tooltip'
import { SgTransfer } from '@sgui-plus/components/transfer'
import { SgTree } from '@sgui-plus/components/tree'
import { SgUpload } from '@sgui-plus/components/upload'

import type { Plugin } from 'vue'

export default [
  SgAlert,
  SgAnchor,
  SgAnchorLink,
  SgAutocomplete,
  SgBadge,
  SgBreadcrumb,
  SgBreadcrumbItem,
  SgButton,
  SgButtonGroup,
  SgCalendar,
  SgCard,
  SgCarousel,
  SgCarouselItem,
  SgCascader,
  SgCascaderPanel,
  SgCheckbox,
  SgCheckboxButton,
  SgCheckboxGroup,
  SgCol,
  SgCollapse,
  SgCollapseItem,
  SgCollapseTransition,
  SgColorPicker,
  SgComboTree,
  SgDatePicker,
  SgDropdown,
  SgDropdownItem,
  SgForm,
  SgFormItem,
  SgIcon,
  SgImage,
  SgInput,
  SgInputNumber,
  SgLink,
  SgLoading,
  SgMenu,
  SgMenuItem,
  SgMenuItemGroup,
  SgSubMenu,
  SgMessage,
  SgModal,
  SgMultiFilter,
  SgNotification,
  SgOption,
  SgOptionGroup,
  SgPage,
  SgPageStatus,
  SgPopconfirm,
  SgPopover,
  SgPopper,
  SgProgress,
  SgRadio,
  SgRadioButton,
  SgRadioGroup,
  SgRate,
  SgResult,
  SgRow,
  SgScrollbar,
  SgSelect,
  SgSlider,
  SgStatistic,
  SgSwitch,
  SgSteps,
  SgStep,
  SgTable,
  SgTableColumn,
  SgTab,
  SgTabPane,
  SgTag,
  SgTimePicker,
  SgTimeSelect,
  SgTimeline,
  SgTimelineItem,
  SgTooltip,
  SgTransfer,
  SgTree,
  SgUpload,
  SgDrawer
] as Plugin[]
